module.exports = __webpack_public_path__ + "c_static/img/3-2手机京东-购物车.1282642.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/收藏购物车/3-2手机京东-购物车.jpg
// module id = cs6B
// module chunks = 33